import Swiper, { Navigation, Autoplay } from 'swiper';

const filterOptions = {
    modules: [Autoplay, Navigation],
    loop: false,
    spaceBetween: 15,
    speed: 1000,
    grabCursor: true,
    slidesPerView: 'auto',
    autoplay: {
        delay: 6000,
        disableOnInteraction: true,
        pauseOnMouseEnter: false
    },
    navigation: {
        nextEl: document.querySelector('.filter-news__swiper-wrapper .swiper-button-next'),
        prevEl: document.querySelector('.filter-news__swiper-wrapper .swiper-button-prev'),
    },
    breakpoints: {
        1600: {
            slidesPerView: 4
        },
        1250: {
            slidesPerView: 3
        },
        900: {
            slidesPerView: 2
        },
        320: {
            slidesPerView: 1
        },
    }
};

let filterSwiper = new Swiper(document.querySelector(".filter-news__swiper"), filterOptions);

const btns = $('.filter-news__nav-item')
btns.each(function () {
    const _this = $(this)
    _this.on('click', function () {
        btns.each(function (i, btn) {
            $(btn).removeClass('active')
        })
        _this.addClass('active')
        doAjaxQuery()
    })
})

$('.filter-news__search').on('keyup', function () {
    const nothing = $('.filter-news__nothing-found')
    const search = $('.filter-news__search').val()

    if (search.length > 2 || nothing.length > 0) {
        doAjaxQuery(search)
    }
})

function doAjaxQuery(search = '') {
    const post_type = $('.filter-news__nav-item.active').attr('data-slug')
    const data = {
        'action': 'get_filter_home',
        'post_type': post_type,
        's': search,
    }
    if (search.length > 2) {
        data['s'] = search
    }
    $.ajax({
        url: myajax.url,
        data: data,
        type: 'POST',
        success: function (data) {
            const wrapper = $('.filter-news__swiper-wrapper .filter-news__swiper')
            wrapper.html('')
            filterSwiper.destroy()
            $(".swiper-wrapper").remove()
            if (data) {
                // const root = $("<div class='filter-news__swiper'><div class='swiper-wrapper'></div></div>")
                const root = $("<div class='swiper-wrapper'></div>")
                wrapper.append(root);
                $(".filter-news__swiper .swiper-wrapper").html(data)
                filterSwiper = new Swiper(".filter-news__swiper", filterOptions);
            } else {
                const root = $("<h3 class='filter-news__nothing-found'>Nothing found</h3>")
                wrapper.append(root);
            }
        },
    });
}